import { inject } from '@angular/core';
import { CanActivateFn, Params, RedirectFunction, Router, UrlTree } from '@angular/router';

// Las direcciones de antes del Catálogo, de cuando vivía dentro de Bodega (/bodega/:obraId/catalogo, /bodega/:obraId/prefijos, /bodega?ir=catalogo).
// Aparte de catalogo.routes.ts para que Bodega y app.routes.ts las usen sin cargar las pantallas del Catálogo.

/**
 * Adónde lleva una dirección de antes del Catálogo: la pestaña Catálogo va a Productos, salvo `?vista=revision` (la sección «Por revisar», que ya
 * no existe) que va a Gestión de Catálogo; `?vista=categorias` se conserva (es una sub-pestaña de Productos). Prefijos va a Prefijos. Lo demás de
 * la consulta se conserva, menos `ir`.
 */
export function direccionDelCatalogo(router: Router, pestana: 'catalogo' | 'prefijos', consulta: Params): UrlTree {
  const { vista, ir: _ir, ...resto } = consulta;
  if (pestana === 'prefijos') return router.createUrlTree(['/catalogo/prefijos'], { queryParams: resto });
  if (vista === 'revision') return router.createUrlTree(['/catalogo/revision'], { queryParams: resto });
  return router.createUrlTree(['/catalogo/productos'], { queryParams: { ...resto, ...(vista === 'categorias' ? { vista } : {}) } });
}

/** Redirección (para `redirectTo`) de una pestaña vieja del Catálogo dentro de Bodega. */
export const aCatalogoDesdeBodega = (pestana: 'catalogo' | 'prefijos'): RedirectFunction => ({ queryParams }) =>
  direccionDelCatalogo(inject(Router), pestana, queryParams);

/**
 * `/bodega?ir=catalogo` (o `ir=prefijos`): los enlaces de antes que entraban a Bodega para llegar al Catálogo. Va ANTES que el permiso de Bodega
 * en la ruta /bodega (app.routes.ts), así que también sirve a quien solo tiene permisos del Catálogo.
 */
export const catalogoFueraDeBodegaGuard: CanActivateFn = (_route, state) => {
  const router = inject(Router);
  const arbol = router.parseUrl(state.url);
  const ruta = state.url.split(/[?#]/)[0].replace(/\/+$/, '');
  const ir = arbol.queryParams['ir'];
  if (ruta === '/bodega' && (ir === 'catalogo' || ir === 'prefijos')) return direccionDelCatalogo(router, ir, arbol.queryParams);
  return true;
};
